import React from 'react';
import styled from 'styled-components';
import { IPreset } from '../../modules/reducers';
import LegacyTemplateConfigurationForm from '../../elements/Collections/TemplateConfigurationForm';
import NewTemplateConfigurationForm from '../../elements/Collections/TemplateConfigurationFormNew';
import { useNewDesign } from '../../hooks/useNewDesign';
import { getReplacementTemplateId } from '../../modules/selectors/templates';

const Wrapper = styled.div``;

interface IProps {
  preset: IPreset;
  onChangeCallback: (data: any) => void;
}

export const PresetDesign: React.FC<IProps> = ({ preset, onChangeCallback }) => {
  const presetDesign = preset.design || {};
  const isNewDesign = useNewDesign();
  const TemplateConfigurationForm = isNewDesign
    ? NewTemplateConfigurationForm
    : LegacyTemplateConfigurationForm;

  return (
    <Wrapper>
      <TemplateConfigurationForm
        formValue={{
          // @ts-ignore
          design: presetDesign,
          // The new design no longer lists the Spring Vibes variants, only Valencia.
          selectedTemplateId: isNewDesign
            ? getReplacementTemplateId(preset._scrappbookGalleryTemplate)
            : preset._scrappbookGalleryTemplate,
          galleryStyle: preset.galleryStyle
        }}
        setValue={(form) => {
          onChangeCallback({
            design: {
              ...presetDesign,
              ...form.design,
              variables: {
                // @ts-ignore
                ...presetDesign.variables,
                ...(form.design || {}).variables
              },
              newVariables: {
                // @ts-ignore
                ...presetDesign.newVariables,
                ...(form.design || {}).newVariables
              }
            },
            galleryStyle: form.galleryStyle || preset.galleryStyle,
            _scrappbookGalleryTemplate: form.selectedTemplateId || preset._scrappbookGalleryTemplate
          });
        }}
      />
    </Wrapper>
  );
};
